import jq from 'jquery';
import _ from 'ext:lodash';
import Framework from 'framework';

const GET = 'GET';
const locationPath = '/bin/lt/location';
const timeout = 30000;

//Export Value
let contract = {};

function headers() {
	return {
		'Content-Type': 'application/json; charset=UTF-8'
	};
}

function ajaxCall(method) {
	return $.ajax({
		url: locationPath,
		method: method,
		timeout: timeout,
		headers: contract.getHeaders(),
		dataType: 'json'
	});
}

const locationService = {
	get(){
		var callMethod = GET;

		return new Promise((resolve, reject)=> {
			contract.ajaxCaller(callMethod)
				.then(
					//Success
					(data, textStatus) => {
						resolve(data);
					},
					//Failure
					(jqXHR, textStatus, errorThrown) => {
						reject(errorThrown);
					});
		});
	}
};

contract = {
	api: locationService,
	ajaxCaller: ajaxCall,
	getHeaders: headers
};

export default contract;
